import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ApprovalDashboardComponent } from './approval-dashboard.component';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { ApproveButtonRendererComponent } from './approve-button-renderer.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ToastrModule } from 'ngx-toastr';
import { CurrencyPipe } from '@angular/common';
import { TreeTableModule } from 'primeng/treetable';

const routes: Routes = [
  {
    path: 'aproval-dashboard',
    component: ApprovalDashboardComponent
  }
];

@NgModule({
  declarations: [
    ApprovalDashboardComponent,
    ApproveButtonRendererComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    AgGridModule,
    FormsModule,
    NgxDatatableModule,
    ToastrModule,
    TreeTableModule
  ],
  providers: [
    CurrencyPipe
  ]
})
export class ApprovalDashboardModule { } 